var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFbBgWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8439 39.9755C14.2003 39.998 -7.5187 39.9714 19.5215 39.9714V24.302H14.2521V18.1877H19.5215V13.6816C19.5215 11.1183 20.2398 9.13059 21.6684 7.71834C23.1011 6.3061 25.0072 5.59998 27.3909 5.59998C29.4153 5.59998 30.9868 5.68161 32.1011 5.84895V11.302H28.8562C27.6725 11.302 26.8725 11.551 26.4602 12.0449C26.048 12.5428 25.8398 13.2857 25.8398 14.2775V18.1837H31.8929L31.0929 24.302H25.8439V39.9755C40.5726 39.9755 36.3286 39.9755 25.8439 39.9755Z",
    fill: "#4781FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFbBgWhite);
export default __webpack_public_path__ + "static/media/icon_fb_bgWhite.f14034046700bd8501718fcb80cba618.svg";
export { ForwardRef as ReactComponent };